import React, { useCallback, useEffect } from 'react';

import { useSelector } from 'react-redux';

import interactionResponse from 'await-interaction-response';
import _get from 'lodash/get';

import { useDevice } from '@bonnet/next/device';

import {
    Button,
    Text,
} from 'reaxl';
import {
    sendClick,
    sendImpressions,
} from 'reaxl-analytics';
import {
    inlineFilterPromoClick,
    inlineFilterPromoImpression,
} from 'reaxl-analytics-handlers';
import { PromoCard } from 'reaxl-listing';

import {
    srpSuggestedFiltersDuck,
} from '@/ducks/srp';

import useSrpNavigation from '@/hooks/useSrpNavigation';

function InlineFilterPromoCard() {
    const device = useDevice();
    const isXs = _get(device, 'is.xs', false);

    const navigateToSrp = useSrpNavigation();

    const suggestedFilter = useSelector(srpSuggestedFiltersDuck.selectors.getFirstSuggestion);

    useEffect(() => {
        sendImpressions({ name: inlineFilterPromoImpression });
    }, []);

    const handleButtonClick = useCallback(async (event) => {
        const { value } = event.target;
        await interactionResponse();
        event.target.value = value;

        sendClick(inlineFilterPromoClick, event, {});

        await navigateToSrp({
            resetPagination: true,
            scroll: !isXs,
            scrollToResultsCount: isXs,
            isNewSearch: true,
            filtersValues: suggestedFilter?.codes,
            action: 'merge',
        });
    }, [navigateToSrp, suggestedFilter, isXs]);

    return suggestedFilter?.name && suggestedFilter?.codes && (
        <PromoCard
            className="col-xs-12 col-sm-4 display-flex"
            data-cmp="InlineFilterPromoCard"
            imgSrc="https://www.autotrader.com/content/static/img/icon/promocard/suggested_chat.png"
            imgHeight="40"
            panelClassName="bg-blue-lightest col-xs-12 col-sm-10"
        >
            <Text
                className="margin-top-3"
                color="primary"
                componentClass="div"
            >
                Only interested in vehicles that are
            </Text>
            <Text
                color="primary"
                componentClass="div"
                size={400}
                weight="bold"
            >
                {`${suggestedFilter.name}?`}
            </Text>
            <Button
                bsSize="small"
                bsStyle="primary"
                onClick={handleButtonClick}
                className="margin-top-3"
            >
                Yes, Update My Search
            </Button>
        </PromoCard>
    );
}

export default InlineFilterPromoCard;
